import { IKImage } from "imagekitio-next";
import React from "react";

type AvatarIconProps = {
  imageName: string;
  alt: string;
};
const urlEndpoint = process.env.NEXT_PUBLIC_BASE_IMAGE_KIT_URL;
const AvatarIconWidth = 50;
const AvatarIconHeight = 50;
const AvatarIconQuality = 100;
const AvatarIcon = (props: AvatarIconProps) => {
  return (
    <IKImage
      urlEndpoint={urlEndpoint}
      path={props?.imageName || "default_image.jpg"}
      quality={AvatarIconQuality}
      transformation={[{ crop: "maintain_ratio" }]}
      width={AvatarIconWidth}
      height={AvatarIconHeight}
      alt={props?.alt}
      lqip={{ active: true, quality: 20 }}
      loading="lazy"
      className="rounded-full w-full h-full "
    />
  );
};

export default AvatarIcon;
